import React, { Component } from 'react';
import { Modal, Button, Table } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class DepartmentDetail extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        params: {},
    }

    show = reviewDepartmentId => {
        this.setState({
            visible: true,
        }, () => {
            this.loadData(reviewDepartmentId);
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = (reviewDepartmentId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryReviewDepartmentLogById,
            data: { reviewDepartmentId },
            dataType: 'json',
            doneResult: res => {
                const { log } = res;
                const { details = [], updateTime = '-', employeeCode, userCompellation = '-' } = log || {};
                this.setState({
                    loading: false,
                    data: details,
                    params: {
                        employeeCode,
                        userCompellation,
                        updateTime: updateTime ? updateTime.slice(0, 10) : '',
                    },
                });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '更新字段',
        dataIndex: 'updateField',
        key: 'updateField',
        width: 130,
    }, {
        title: '更新前',
        dataIndex: 'updateBefore',
        key: 'updateBefore',
        width: 215,
    }, {
        title: '更新后',
        dataIndex: 'updateAfter',
        key: 'updateAfter',
        width: 215,
    }]
    
    getDataSource = () => {
        const dataSource = [];
        const { data } = this.state;
        data.map((item, index) => {
            dataSource.push({
                index: index + 1,
                ...item,
            });
        });
        return dataSource;
    }

    render() {
        const { visible, loading } = this.state;
        const { params: { updateTime, employeeCode, userCompellation } } = this.state;
        return (
            <Modal
                title="更新明细"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                width="640px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        更新日期：{updateTime}
                        <span className="ant-divider" />
                        更新者：{userCompellation}{employeeCode ? `(${employeeCode})` : ''}
                    </div>
                    <div>
                        <Table  
                            loading={loading}
                            pagination={false}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.index}
                            scroll={{ x: 560, y: 280 }}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

class PITeamDetail extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        params: {},
        record: {},
    }

    show = record => {
        this.setState({
            visible: true,
            record,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { record: { reviewPiId } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryReviewPiLogById,
            data: { reviewPiId },
            dataType: 'json',
            doneResult: res => {
                const { log } = res;
                const { details = [], updateTime = '-', employeeCode, userCompellation = '-' } = log || {};
                this.setState({
                    loading: false,
                    data: details,
                    params: {
                        employeeCode,
                        userCompellation,
                        updateTime: updateTime ? updateTime.slice(0, 10) : '',
                    },
                });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '更新字段',
        dataIndex: 'updateField',
        key: 'updateField',
        width: 130,
    }, {
        title: '更新前',
        dataIndex: 'updateBefore',
        key: 'updateBefore',
        width: 215,
    }, {
        title: '更新后',
        dataIndex: 'updateAfter',
        key: 'updateAfter',
        width: 215,
    }]
    
    getDataSource = () => {
        const dataSource = [];
        const { data } = this.state;
        data.map((item, index) => {
            dataSource.push({
                index: index + 1,
                ...item,
            });
        });
        return dataSource;
    }

    render() {
        const { visible, loading } = this.state;
        const { params: { updateTime, employeeCode, userCompellation } } = this.state;
        return (
            <Modal
                title="更新明细"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                width="640px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        更新日期：{updateTime}
                        <span className="ant-divider" />
                        更新者：{userCompellation}{employeeCode ? `(${employeeCode})` : ''}
                    </div>
                    <div>
                        <Table  
                            loading={loading}
                            pagination={false}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.index}
                            scroll={{ x: 560, y: 280 }}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

class ResearcherDetail extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        params: {},
        record: {},
    }

    show = record => {
        this.setState({
            visible: true,
            record,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { record: { reviewResearcherId } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryReviewResearcherLogById,
            data: { reviewResearcherId },
            dataType: 'json',
            doneResult: res => {
                const { log } = res;
                const { details = [], updateTime = '-', employeeCode, userCompellation = '-' } = log || {};
                this.setState({
                    loading: false,
                    data: details,
                    params: {
                        employeeCode,
                        userCompellation,
                        updateTime: updateTime ? updateTime.slice(0, 10) : '',
                    },
                });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '更新字段',
        dataIndex: 'updateField',
        key: 'updateField',
        width: 130,
    }, {
        title: '更新前',
        dataIndex: 'updateBefore',
        key: 'updateBefore',
        width: 215,
    }, {
        title: '更新后',
        dataIndex: 'updateAfter',
        key: 'updateAfter',
        width: 215,
    }]
    
    getDataSource = () => {
        const dataSource = [];
        const { data } = this.state;
        data.map((item, index) => {
            dataSource.push({
                index: index + 1,
                ...item,
            });
        });
        return dataSource;
    }

    render() {
        const { visible, loading } = this.state;
        const { params: { updateTime, employeeCode, userCompellation } } = this.state;
        return (
            <Modal
                title="更新明细"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                width="640px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        更新日期：{updateTime}
                        <span className="ant-divider" />
                        更新者：{userCompellation}{employeeCode ? `(${employeeCode})` : ''}
                    </div>
                    <div>
                        <Table  
                            loading={loading}
                            pagination={false}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.index}
                            scroll={{ x: 560, y: 280 }}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export { DepartmentDetail, PITeamDetail, ResearcherDetail };


// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/UpdateDetail.js